import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import {TYPES as filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic/lib/config'

import {filterName, LEGEND_STEP_2} from '../config.js'
import {QuestionRenderer} from './QuestionRenderer.js'

export class MultiselectQuestionRenderer extends QuestionRenderer {
  render({options, onOptionsChange, selectedOptions, typeSelection}) {
    return (
      <FilterWrapperBasic
        filters={[{name: filterName, options, type: typeSelection}]}
        group={`${filterName}Group`}
        legend={LEGEND_STEP_2}
        onChange={onOptionsChange}
        value={{[filterName]: selectedOptions}}
        wrapper={filterWrapperBasicTypes.NONE}
      />
    )
  }
}
